import React, { useState } from 'react'
import styles from './dropdown.module.scss'
import cls from 'classnames'

export type TDropdownProps = {
  arrow?: boolean
  arrowIconClass?: string
  children: React.ReactNode
  text: string | React.ReactNode
  width?: string
  style?: React.CSSProperties
  textAlign?: 'left' | 'center' | 'right'
  placement?: 'top' | 'bottom' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight'
  size?: 's' | 'default' // 暂定 s m default, 后续根据需求增加 xs xl l 等
  trigger?: 'click' | 'hover'
  onOpenChange?: (open: boolean) => void
}

export default function Dropdown(props: TDropdownProps) {
  const { arrow = true, arrowIconClass = 'iconn-xiajiantou', trigger = 'hover', placement = 'bottomLeft' } = props
  const [showDropdown, setShowDropdown] = useState<boolean>(false)
  return (
    <div
      onMouseEnter={() => {
        if (trigger === 'click') return
        props?.onOpenChange?.(true)
      }}
      onMouseLeave={() => {
        if (trigger === 'click') return
        props?.onOpenChange?.(false)
      }}
      onBlurCapture={() => {
        if (trigger === 'hover') return
        props?.onOpenChange?.(false)
        setShowDropdown(false)
      }}
      className={cls(styles.dropdown, styles[`size-${props.size}`], {
        [styles.hoverTrigger]: trigger === 'hover',
        [styles.clickTrigger]: trigger === 'click' && showDropdown,
      })}
    >
      <div
        style={{ width: props.width, textAlign: props.textAlign, ...props.style }}
        className={cls(styles.preview)}
        onClick={() => {
          if (trigger === 'hover') return
          props?.onOpenChange?.(!showDropdown)
          setShowDropdown((state) => !state)
        }}
      >
        <span className="f12 c7">{props.text}</span>{' '}
        {arrow && <i className={cls(styles.icon, 'iconfont', arrowIconClass)} />}
      </div>
      <div
        className={cls(styles.dropdownContentBox, styles[placement])}
        onMouseDown={(event) => {
          event.preventDefault()
        }}
      >
        <div className={styles.dropdownContent}>{props.children}</div>
      </div>
    </div>
  )
}
